import React, { Fragment, useEffect, useState } from 'react';
import { styled, css } from 'styled-components';
import { Colors, hexToRGB } from '../../../../play-core/styles/Colors';
import { times } from '../../../../play-core/utils/times';
import { jsx as _jsx } from "react/jsx-runtime";
const maxLargeIndicatorCount = 5;
const defaultLargeIndicatorCount = 3;
const fadeOutIndicatorCount = 2;
const getFirstLargeIndicator = (activeIndex, currentIndex, largeIndicatorCount) => {
  if (activeIndex > currentIndex + (largeIndicatorCount - 1)) {
    return activeIndex - (largeIndicatorCount - 1);
  }
  if (activeIndex < currentIndex) {
    return activeIndex;
  }
  return currentIndex;
};
export const Indicator = ({
  activeIndex,
  count,
  slideToIndex,
  className
}) => {
  const largeIndicatorCount = count > maxLargeIndicatorCount ? defaultLargeIndicatorCount : count;
  const [firstLargeIndicatorIdx, setFirstLargeIndicatorIdx] = useState(activeIndex);
  useEffect(() => {
    setFirstLargeIndicatorIdx(currentIdx => getFirstLargeIndicator(activeIndex, currentIdx, largeIndicatorCount));
  }, [activeIndex, largeIndicatorCount]);
  if (count < 2) {
    return /*#__PURE__*/_jsx(Fragment, {});
  }
  return /*#__PURE__*/_jsx(StyledIndicator, {
    className: className,
    children: /*#__PURE__*/_jsx(Container, {
      count: count,
      firstLargeIndicatorIdx: firstLargeIndicatorIdx,
      largeIndicatorCount: largeIndicatorCount,
      children: times(count, index => /*#__PURE__*/_jsx(Item, {
        largeIndicatorCount: largeIndicatorCount,
        firstLargeIndicatorIdx: firstLargeIndicatorIdx,
        index: index,
        onClick: () => slideToIndex(index),
        children: /*#__PURE__*/_jsx(SelectedItem, {
          isActive: activeIndex === index
        })
      }, index))
    })
  });
};
const StyledIndicator = styled.div.withConfig({
  displayName: "Indicator__StyledIndicator",
  componentId: "sc-110ab3d-0"
})(["display:flex;justify-content:center;"]);
const Container = styled.div.withConfig({
  displayName: "Indicator__Container",
  componentId: "sc-110ab3d-1"
})(["position:relative;display:flex;justify-content:center;gap:6px;transition:transform 200ms ease-in-out;will-change:transform;transform:", ";"], ({
  count,
  firstLargeIndicatorIdx,
  largeIndicatorCount
}) =>
// First translate to offset the hidden indicators and then apply a negative translate as the active indicator changes
`translateX(calc(${(count - largeIndicatorCount) / count * 100 / 2}% - ${firstLargeIndicatorIdx / count * 100}%))`);
const itemStyle = css(["width:8px;height:8px;border-radius:50%;"]);
const Item = styled.div.withConfig({
  displayName: "Indicator__Item",
  componentId: "sc-110ab3d-2"
})(["", " background-color:", ";cursor:pointer;background-clip:content-box;box-sizing:content-box;transition:transform 200ms ease-in-out;position:relative;will-change:transform;transform:", ";"], itemStyle, hexToRGB(Colors.WHITE, 0.2), ({
  firstLargeIndicatorIdx,
  index,
  largeIndicatorCount
}) => `scale(${getScale(index, firstLargeIndicatorIdx, largeIndicatorCount)})`);
const SelectedItem = styled.div.withConfig({
  displayName: "Indicator__SelectedItem",
  componentId: "sc-110ab3d-3"
})(["", " position:absolute;background-color:", ";opacity:", ";will-change:opacity;transition:opacity 200ms ease-in-out;"], itemStyle, Colors.RED_8b0019, ({
  isActive
}) => isActive ? 1 : 0);
const getScale = (index, firstLargeIndicatorIdx, largeIndicatorCount) => {
  const lastLargeIndicatorIdx = firstLargeIndicatorIdx + (largeIndicatorCount - 1);
  const distanceToRange = index > lastLargeIndicatorIdx ? index - lastLargeIndicatorIdx : index < firstLargeIndicatorIdx ? firstLargeIndicatorIdx - index : 0;
  return Math.max(0, 1 - distanceToRange / (fadeOutIndicatorCount + 1));
};